export default "__VITE_ASSET__BXXyTWAN__"